import React from 'react';
import { Box, Flex, Image } from '@chakra-ui/react';
import bannerDesktop from 'assets/images/banner-desktop.jpg';
import bannerMobile from 'assets/images/banner-mobile.jpg';
import { motion } from 'framer-motion';

const MotionFlex = motion(Flex);

const Banner: React.FC = () => {
  const [currentIndex, setCurrentIndex] = React.useState(0);

  const images = [
    { desktop: bannerDesktop, mobile: bannerMobile },
    { desktop: bannerDesktop, mobile: bannerMobile },
  ];

  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box position="relative" width="full" overflow="hidden">
      <MotionFlex
        width="full"
        animate={{ x: `-${currentIndex * 100}%` }}
        transition={{ duration: 0.6, ease: 'easeInOut' }}
      >
        {images.map((src, index) => (
          <Box key={index} flex="0 0 100%">
            <Image
              src={src.mobile}
              alt={`Slide ${index}`}
              width="100%"
              objectFit="contain"
              borderRadius={8}
              display={{ base: 'block', lg: 'none' }}
            />
            <Image
              src={src.desktop}
              alt={`Slide ${index}`}
              width="100%"
              objectFit="contain"
              borderRadius={8}
              display={{ base: 'none', lg: 'block' }}
            />
          </Box>
        ))}
      </MotionFlex>
    </Box>
  );
};

export default Banner;
